<template>
  <div class="AssignmentView">
    <img alt="Leadtributor logo" src="../assets/leadtributor-logo-text.png" width="500">

    <!-- Breadcrumbs -->
    <v-row>
      <v-breadcrumbs
        :items="breadcrumb_items"
        divider=">"
      ></v-breadcrumbs>
    </v-row>

    <!-- BannerDialog -->
    <AssignmentBannerDialog
      :open="open_banner" 
      :items_beauftragter="items_beauftragter"
      :items_bearbeiter="items_bearbeiter"
      :items_pipeline="items_pipeline"
      @cancel="closeBanner" 
      @assign-lead="assignLead" />

    <!-- ActionButtons -->
    <v-row>
      <v-col cols="12" class="d-flex justify-end">
        <ButtonAssignmentRemove @click="removeAssignment" />
        <ButtonSecondaryAction @click="deleteAssignment" />
        <ButtonAssignment @click="openBanner" />
      </v-col>
    </v-row>

  </div>
</template>

<script>
import ButtonAssignment from "@/components/buttons/ButtonAssignment";
import ButtonAssignmentRemove from "@/components/buttons/ButtonAssignmentRemove";
//delete Button
import ButtonSecondaryAction from "@/components/buttons/ButtonSecondaryAction";
import AssignmentBannerDialog from "@/components/form/AssignmentBannerDialog";
import {ref} from "@vue/composition-api";

export default {
  name: "AssignmentView",
  components: {
      ButtonAssignment,
      ButtonAssignmentRemove,
      ButtonSecondaryAction,
      AssignmentBannerDialog
    },
  setup(){
    //breadcrumbs
    const breadcrumb_items = [
      {
        text: 'Dashboard',
        disabled: false,
        href: '/#/',
      },
      {
        text: 'CardView',
        disabled: false,
        href: '/#/card-view',
      },
      {
        text: 'AssignmentView',
        disabled: true,
        href: '/#/assignment-view',
      },
    ];

    //banner
    const open_banner = ref(false);
    const toggleBanner = function(){
      open_banner.value = !open_banner.value;
    }
    const openBanner = function(){
      open_banner.value = true;
    }
    const closeBanner = function(){
      open_banner.value = false;
    }

    const items_beauftragter = [
      {
        id: 1,
        name: 'Andre 5204'
      },
      {
        id: 2,
        name: 'Omega Ultra',
        imageSrc: 'https://picsum.photos/46?random=2',
        active: true
      },
      {
        id: 3,
        name: 'OMAHA GMBH',
        imageSrc: 'https://picsum.photos/46?random=3'
      },
      {
        id: 4,
        name: 'Utah Concordia',
        imageSrc: 'https://picsum.photos/46?random=4'
      },
      {
        id: 5,
        name: 'Calmaris GmbH'
      },
      {
        id: 6,
        name: 'Andre 5204'
      },
      {
        id: 7,
        name: 'Omega Ultra',
        imageSrc: 'https://picsum.photos/46?random=5'
      },
      {
        id: 8,
        name: 'OMAHA GMBH'
      },
      {
        id: 9,
        name: 'Utah Concordia'
      },
      {
        id: 10,
        name: 'Calmaris GmbH'
      }
    ];
    
    const items_bearbeiter = [
      {
        id: 1,
        name: 'Marcell'
      },
      {
        id: 2,
        name: 'Erik'
      }
    ];

    const items_pipeline = [
      {
        id: 1,
        name: 'Fox',
        group: ['Group1', 'Group2', 'Group3'],
        imageSrc: 'https://picsum.photos/46?random=6'
      },
      {
        id: 2,
        name: 'Delta',
        group: ['Group2', 'Group3'],
        imageSrc: 'https://picsum.photos/46?random=7'
      },
      {
        id: 3,
        name: 'Tango',
        group: ['Group5'],
        imageSrc: 'https://picsum.photos/46?random=8'
      }
    ];

    //ok - assign lead
    //todo submit data with event
    const assignLead = function(assignment_data){
      console.log(assignment_data);
      console.log('assignLead');
      closeBanner();
    }

    const removeAssignment = () => {
      console.log("removeAssignment");
    }

    const deleteAssignment = () => {
      console.log("deleteAssignment");
    }

    return {open_banner, toggleBanner, openBanner, closeBanner, assignLead, removeAssignment, deleteAssignment, 
      breadcrumb_items, items_beauftragter, items_bearbeiter, items_pipeline};
  }
}
</script>

<style scoped lang="scss">
  .AssignmentView{
    position: relative;
    
    .ButtonPrimaryAssignment{
      margin-left: auto;
      margin-right: 0;
    }
  }
</style>
